import { Theme } from '@mui/material/styles';

// ----------------------------------------------------------------------

export default function CircularProgress(theme: Theme) {
  // const isLight = theme.palette.mode === 'light';

  return {
    MuiCircularProgress: {
      styleOverrides: {
        root: {
        },
        secondary:{
          color: `linear-gradient(90deg, #6fcbb6 50%, #9c64f4 100%)`

        },
        circle: ({ progress }: any) => ({
          borderRadius: 5,

        })
      }
    }
  };
}
